"use strict";

exports.__esModule = true;
var _DeviceTag = require("./DeviceTag");
Object.keys(_DeviceTag).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceTag[key]) return;
  exports[key] = _DeviceTag[key];
});
var _DeviceTagList = require("./DeviceTagList");
Object.keys(_DeviceTagList).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DeviceTagList[key]) return;
  exports[key] = _DeviceTagList[key];
});